import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";

export const SiteTabsContainer = styled.div`
    display: flex;
    width: 100%;
    > div {
        border: 1px solid ${colorsPalettes.carbon[50]};
        border-left: none;
    }
    > div:first-child {
        border: 1px solid ${colorsPalettes.carbon[50]};
    }
`;

export const SiteTabContainer = styled.div<{ isSelected: boolean }>`
    display: flex;
    column-gap: 9px;
    padding: 14px 16px;
    width: 17%;
    cursor: pointer;
    height: 17px;
    &:hover {
        background-color: ${colorsPalettes.carbon[25]};
    }
    ${({ isSelected }) => `
        background-color: ${isSelected ? colorsPalettes.bluegrey[100] : colorsPalettes.carbon[0]};
        border-bottom: ${
            isSelected ? `2px solid ${colorsPalettes.blue[400]}` : `1px solid ${colorsPalettes.carbon[50]}`
        } !important;
        padding-bottom: ${isSelected ? 13 : 14}px;
    `};
`;

export const Dot = styled.div<{ color: string; setOpacity: boolean }>`
    align-self: center;
    height: 10px;
    width: 10px;
    border-radius: 8px;
    ${({ color }) => `background-color:${color}`}
    opacity: ${({ setOpacity }) => (setOpacity ? 0.7 : 1)};
`;

export const Site = styled.span<{ isSelected: boolean; setOpacity: boolean }>`
    align-self: center;
    ${({ isSelected }) => `color: ${isSelected ? colorsPalettes.blue[400] : colorsPalettes.midnight[200]}`}
    ${setFont({ $size: 14, $weight: 400 })};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 5;
    opacity: ${({ setOpacity }) => (setOpacity ? 0.7 : 1)};
`;
